<script setup>
defineProps(['value']);
</script>

<template>
    <i :class="{
        'text-green-600 fas fa-check': !!value,
        'text-red-600 fas fa-close': !value
    }"/>
</template>

<style scoped>

</style>
